const SELECT_CASES_FILTER_COLLABORATORS = [
  { name: "Nome", value: 1 },
  { name: "E-mail", value: 2 },
  { name: "CPF", value: 3 },
  { name: "RG", value: 4 },
  { name: "Contrato", value: 5 },
  { name: "Cargo", value: 6 },
  { name: "Tecnologia", value: 7 },
];

const CASES_FILTER_COLLABORATORS = ["name", "email", "CPF", "RG", "contract_type", "job_role", "technology", "finaly"];

export { SELECT_CASES_FILTER_COLLABORATORS, CASES_FILTER_COLLABORATORS };

export const THEADERMOCK = [
  { name: "Nome", value: "name" },
  { name: "CPF", value: "CPF" },
  { name: "Telefone", value: "phone" },
  { name: "Cargo", value: "job_role" },
  { name: "Regime de Contratação", value: "contract_type" },
  { name: "Faturado", value: "isBilled" },
  { name: "Data admissão", value: "beginnig_at" },
  { name: "Data demissão", value: "end_date" },
  { name: "Data de nascimento", value: "birth_date" },
];
